import { render, staticRenderFns } from "./FormControlTypeTel.vue?vue&type=template&id=2bd592da&scoped=true"
import script from "./FormControlTypeTel.vue?vue&type=script&lang=js"
export * from "./FormControlTypeTel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd592da",
  null
  
)

export default component.exports